import axios from 'axios'

const api = axios.create({
    baseURL: 'http://localhost:8080/game',
    headers: {
        'Content-Type': 'application/json'
    }
})

export default {
    createGame(playerName) {
        return api.post('/create', { playerName })
    },
    drawCard(gameId) {
        return api.post(`/${gameId}/draw`)
      },
    joinGame(gameId, playerName) {
        return api.post('/join', { gameId, playerName })
    },
    // 添加 insertCard 方法
  insertCard(gameId, playerId, card, position) {
    return api.post(`/${gameId}/insert`, {
      playerId,
      card,
      position
    })
  },
    getGameState(gameId) {
        return api.get(`/${gameId}`)
    },
    makeGuess(gameId, guesserId, targetId, position, number, color) {
        return api.post('/guess', {
            gameId,
            guesserId,
            targetId,
            position,  // 新增参数
            number,
            color: color.toUpperCase() // 确保大写
        })
    },
    getAvailableGames() {
        return axios.get('/game/available')
    }
}